__turbopack_context__.v({
  "aside": "FirstRunIntro-module__tHrHbq__aside",
  "caret": "FirstRunIntro-module__tHrHbq__caret",
  "caret-out": "FirstRunIntro-module__tHrHbq__caret-out",
  "choice": "FirstRunIntro-module__tHrHbq__choice",
  "choices": "FirstRunIntro-module__tHrHbq__choices",
  "choose": "FirstRunIntro-module__tHrHbq__choose",
  "dawn": "FirstRunIntro-module__tHrHbq__dawn",
  "fit": "FirstRunIntro-module__tHrHbq__fit",
  "gloss": "FirstRunIntro-module__tHrHbq__gloss",
  "grain": "FirstRunIntro-module__tHrHbq__grain",
  "howItWorks": "FirstRunIntro-module__tHrHbq__howItWorks",
  "invite-rim": "FirstRunIntro-module__tHrHbq__invite-rim",
  "invite-sweep": "FirstRunIntro-module__tHrHbq__invite-sweep",
  "languagePill": "FirstRunIntro-module__tHrHbq__languagePill",
  "lead": "FirstRunIntro-module__tHrHbq__lead",
  "leadLine": "FirstRunIntro-module__tHrHbq__leadLine",
  "level": "FirstRunIntro-module__tHrHbq__level",
  "lockup": "FirstRunIntro-module__tHrHbq__lockup",
  "meaning": "FirstRunIntro-module__tHrHbq__meaning",
  "micNote": "FirstRunIntro-module__tHrHbq__micNote",
  "more": "FirstRunIntro-module__tHrHbq__more",
  "moreCount": "FirstRunIntro-module__tHrHbq__moreCount",
  "planet": "FirstRunIntro-module__tHrHbq__planet",
  "ready": "FirstRunIntro-module__tHrHbq__ready",
  "rim": "FirstRunIntro-module__tHrHbq__rim",
  "rimFade": "FirstRunIntro-module__tHrHbq__rimFade",
  "scene": "FirstRunIntro-module__tHrHbq__scene",
  "setting": "FirstRunIntro-module__tHrHbq__setting",
  "settingLabel": "FirstRunIntro-module__tHrHbq__settingLabel",
  "settingPill": "FirstRunIntro-module__tHrHbq__settingPill",
  "settings": "FirstRunIntro-module__tHrHbq__settings",
  "shine": "FirstRunIntro-module__tHrHbq__shine",
  "signIn": "FirstRunIntro-module__tHrHbq__signIn",
  "sky": "FirstRunIntro-module__tHrHbq__sky",
  "spin": "FirstRunIntro-module__tHrHbq__spin",
  "srOnly": "FirstRunIntro-module__tHrHbq__srOnly",
  "stage": "FirstRunIntro-module__tHrHbq__stage",
  "start": "FirstRunIntro-module__tHrHbq__start",
  "startIcon": "FirstRunIntro-module__tHrHbq__startIcon",
  "startLabel": "FirstRunIntro-module__tHrHbq__startLabel",
  "startRow": "FirstRunIntro-module__tHrHbq__startRow",
  "sunPlace": "FirstRunIntro-module__tHrHbq__sunPlace",
  "sunrise": "FirstRunIntro-module__tHrHbq__sunrise",
  "top": "FirstRunIntro-module__tHrHbq__top",
  "voice": "FirstRunIntro-module__tHrHbq__voice",
  "voiceLine": "FirstRunIntro-module__tHrHbq__voiceLine",
  "word": "FirstRunIntro-module__tHrHbq__word",
});
